<!--加载页-->
<template>
  <div class="loading">
    <van-loading type="spinner" vertical>加载中...</van-loading>
  </div>
</template>
<script>
export default {
  name: "loading",
  data() {
    return {};
  },
  created() {
    let {token, openId, userType} = this.$route.query;
    let user_token = window.localStorage.getItem("user_token");

    let skipAddress = decodeURIComponent(window.sessionStorage.getItem("skipAddress"))

    const local = (skipAddress && skipAddress != 'null') ? skipAddress : this.BASE.BASE_URL;
    if (user_token && openId && user_token != "undefined" && openId != "undefined") {
      let data = {
        openid: openId,
        token: user_token,
      };
      this.$post("user/loginBind", data).then((res) => {
        if (res.status === 200) {
          window.location.replace(local);
        }
      });
    } else if (token && token != "undefined") {
      window.localStorage.setItem("user_token", token);
      window.localStorage.setItem("user_type", userType); //userType 0是普通用户，1医护人员，2配送人员
      window.location.replace(local);
    } else if (openId && openId != "undefined") {
      this.$router.replace(`/authorization?openId=${openId}`);
    }
  },
  methods: {},
};
</script>
<style lang='less' scoped>
.loading {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>